import React from "react";
import PropTypes from "prop-types";
import RatingEmoji from "./RatingEmoji";
import {
  RatingStepWrapper,
  Title,
  ReviewTitle,
  Rating,
  Input,
  Label,
  StepCount,
} from "../styles/form-steps-styles";

const CommunicationStep = ({
  setRating,
  rating,
  recruiterName,
  agencyName,
}) => (
  <RatingStepWrapper noPointerEvents={rating} className="animated fadeIn">
    <Title data-test-id="step1-rating-title">
      Please leave a review for <strong>{recruiterName}</strong> at{" "}
      <strong>{agencyName}</strong>
    </Title>
    <RatingEmoji rating={rating} />
    <ReviewTitle
      className="animated fadeIn delay-3"
      data-test-id="step1-review-title"
    >
      Communication
    </ReviewTitle>
    <Rating className="rating animated fadeIn delay-4">
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="communicationRating"
        id="rating-15"
        value={5}
        data-test-id="step-rating-input"
      />
      <Label htmlFor="rating-15" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="communicationRating"
        id="rating-14"
        value={4}
      />
      <Label htmlFor="rating-14" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="communicationRating"
        id="rating-13"
        value={3}
      />
      <Label htmlFor="rating-13" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="communicationRating"
        id="rating-12"
        value={2}
      />
      <Label htmlFor="rating-12" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="communicationRating"
        id="rating-11"
        value={1}
      />
      <Label htmlFor="rating-11" />
    </Rating>
    <StepCount data-test-id="step-count">step 1 of 5</StepCount>
  </RatingStepWrapper>
);

CommunicationStep.propTypes = {
  setRating: PropTypes.func.isRequired,
  recruiterName: PropTypes.string.isRequired,
  agencyName: PropTypes.string.isRequired,
  rating: PropTypes.number,
};

CommunicationStep.defaultProps = {
  rating: PropTypes.isNull,
};

export default CommunicationStep;
